import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import shopProductService from "../services/singleShopProducts";
import shopDraftProductService from "../services/singleShopDraftProduct";
const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  form: {
    emptyForm: true,
    preFilledForm: true,
    preFilledData: {},
    selectedSubcategoryRef: null,
    variantStatus: false,
    isReturn: null,
    selectedCategory: null,
  },
  allCatalogProduct: [],
  searchParams: { draft: "true" },
  shopProductType: false,
  productName: null,
  subCategory: null,
  brand: null,
  maxImagesCount: null,
  isActive: null,
  filter: null,
  barcode: null,
  isOldStock: null,
  isOutOfStock: null,
  dataSource: null,
  domain: null,
  isFilterApplied: false,
  created_at: null,
  modified_at: null,
  currentPage: 1,
  productSearchWithName: [],
  productSearchWithBarcode: [],
  shouldCallApi: true,
  draftValidation: false,
  productValidation: false,
};

const Slice: sagaSlice = createSlice({
  ...persist("allShopProductManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchShopProducts", "list"),
    ...createSagaReducer("fetchShopDraftProduct", "list"),
    setEmptyForm: (state, action) => {
      state.form.emptyForm = action.payload;
    },
    setPreFilledForm: (state, action) => {
      state.form.preFilledForm = action.payload;
    },
    setPreFilledData: (state, action) => {
      state.form.preFilledData = action.payload;
    },
    updateSelectedSubcategoryRef(state, action) {
      state.form.selectedSubcategoryRef = action.payload;
    },
    updateVariantStatus(state, action) {
      state.form.variantStatus = action.payload;
    },
    updateProductName(state, action) {
      state.productName = action.payload;
    },
    updateSubCategory(state, action) {
      state.subCategory = action.payload;
    },
    updateBrand(state, action) {
      state.brand = action.payload;
    },
    updateImageCount(state, action) {
      state.maxImagesCount = action.payload;
    },
    updateStatus(state, action) {
      state.isActive = action.payload;
    },
    updateFilter(state, action) {
      state.filter = action.payload;
    },
    updateBarcode(state, action) {
      state.barcode = action.payload;
    },
    updateIsOldStock(state, action) {
      state.isOldStock = action.payload;
    },
    updateIsOutOfStock(state, action) {
      state.isOutOfStock = action.payload;
    },
    updateDataSource(state, action) {
      state.dataSource = action.payload;
    },
    updateDomain(state, action) {
      state.domain = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    updateShopProductType(state, action) {
      state.shopProductType = action.payload;
    },
    updateIsReturn(state, action) {
      state.form.isReturn = action.payload;
    },
    setSelectedCategory(state, action) {
      state.form.selectedCategory = action.payload;
    },
    updateCreatedAt(state, action) {
      state.created_at = action.payload;
    },
    updateModifiedAt(state, action) {
      state.modified_at = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    updateAllCatalogProduct(state, action) {
      state.allCatalogProduct = action.payload;
    },
    updateProductSearchWithName(state, action) {
      state.productSearchWithName = action.payload;
    },
    updateProductSearchWithBarcode(state, action) {
      state.productSearchWithBarcode = action.payload;
    },
    updateDraftValidation(state, action) {
      state.draftValidation = action.payload;
    },
    updateShouldCallApi(state, action) {
      state.shouldCallApi = action.payload;
    },
    updateProductValidation(state, action) {
      state.productValidation = action.payload;
    },
  },
});

const fetchAllShopProduct = createAsyncSaga(
  "fetchShopProducts",
  Slice,
  shopProductService.fetchShopProducts,
  [
    "shopId",
    "currentPage",
    "itemsPerPage",
    "productName",
    "subCategory",
    "brand",
    "maxImagesCount",
    "isActive",
    "emptyImagesArray",
    "barcode",
    "isOldStock",
    "isOutOfStock",
    "dataSource",
    "created_at",
    "modified_at",
    "domain",
  ]
);

addSaga(Slice.actions.fetchShopProducts.type, fetchAllShopProduct);

const fetchAllShopDraftProduct = createAsyncSaga(
  "fetchShopDraftProduct",
  Slice,
  shopDraftProductService.fetchShopDraftProduct,
  [
    "shopId",
    "currentPage",
    "itemsPerPage",
    "productName",
    "subCategory",
    "brand",
    "maxImagesCount",
    "isActive",
    "emptyImagesArray",
    "barcode",
    "isOldStock",
    "isOutOfStock",
    "dataSource",
    "created_at",
    "modified_at",
    "domain",
  ]
);

addSaga(Slice.actions.fetchShopDraftProduct.type, fetchAllShopDraftProduct);

export const {
  fetchShopProducts,
  setEmptyForm,
  setPreFilledForm,
  setPreFilledData,
  updateSelectedSubcategoryRef,
  updateVariantStatus,
  updateProductName,
  updateSubCategory,
  updateBrand,
  updateImageCount,
  updateStatus,
  updateFilter,
  updateBarcode,
  updateIsOldStock,
  updateIsOutOfStock,
  updateDataSource,
  updateDomain,
  updateFilterButton,
  updateShopProductType,
  fetchShopDraftProduct,
  updateIsReturn,
  setSelectedCategory,
  updateCreatedAt,
  updateModifiedAt,
  setCurrentPage,
  updateAllCatalogProduct,
  updateProductSearchWithName,
  updateProductSearchWithBarcode,
  updateDraftValidation,
  updateShouldCallApi,
  updateProductValidation,
} = Slice.actions;

export default Slice.reducer;
